module.exports = __webpack_public_path__ + "img/max-office-building-approve.61d1c3bd.svg";